import React from "react"
import { aboutInfo } from "../../Util/People.js"
import { FaUserGraduate, FaEnvelope, FaExternalLinkAlt, FaUser } from "react-icons/fa"
import "./About.css"

export function About() {
	return (
		<React.Fragment>
			<main className="page about-page flex-grow-1 d-flex flex-column">
				<section className="about-us-section pt-3 pb-5 flex-grow-1">
					<div className="container">
						<div className="about-header text-center mb-4">
							<h1 className="fw-bold text-dark h2 mb-2">Nossa Equipe</h1>
							<p className="text-muted small mx-auto" style={{ maxWidth: "650px" }}>
								Conheça os professores, orientadores, pesquisadores de pós-graduação e bolsistas de iniciação científica do Núcleo de Ciência de Dados
								e IA (UNIFOR).
							</p>
						</div>


						{/* Team Grid */}
						<div className="row g-4 justify-content-center">
							{aboutInfo.map((person, index) => (
								<div className="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex" key={index}>

									<div className="card text-center team-modern-card w-100 d-flex flex-column rounded-4 bg-white border shadow-sm">
										<div className="team-avatar-wrapper mt-4 mx-auto position-relative">
											{person.foto ? (
												<img className="team-avatar-img rounded-circle" src={person.foto} alt={person.name} />
											) : (
												<div className="team-avatar-fallback rounded-circle d-flex align-items-center justify-content-center text-secondary">
													<FaUser size={36} className="opacity-50" />
												</div>
											)}
											{person.graduationLevel && (
												<span className="badge team-badge-tag bg-primary text-white position-absolute bottom-0 start-50 translate-middle-x shadow-sm">
													{person.graduationLevel}
												</span>
											)}
										</div>

										<div className="card-body d-flex flex-column justify-content-between p-3 mt-2">
											<div>
												<h3 className="team-member-name fs-6 fw-bold text-dark mb-1">{person.name}</h3>
												{person.position && <p className="text-muted small mb-2">{person.position}</p>}
											</div>

											{(person.email || person.lattes) && (
												<div className="team-actions mt-3 d-flex flex-column gap-2">
													{person.email && (
														<a
															href={`mailto:${person.email}`}
															className="btn btn-sm btn-outline-secondary rounded-pill d-inline-flex align-items-center justify-content-center gap-2"
															title={person.email}
														>
															<FaEnvelope size={12} /> <span className="text-truncate">{person.email}</span>
														</a>
													)}
													{person.lattes && (
														<a
															href={person.lattes}
															target="_blank"
															rel="noopener noreferrer"
															className="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center justify-content-center gap-2"
														>
															<FaUserGraduate size={12} /> Lattes <FaExternalLinkAlt size={10} />
														</a>
													)}
												</div>
											)}
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</section>
			</main>
		</React.Fragment>
	)
}
